import React, { useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import { connect } from 'formik'
import { useTranslation } from 'next-i18next'

import { getCompanySizeMap } from '../../utils/helpers'

const CompanyInfoFieldsGroup = ({
  formik,
  industryValues,
  canEdit,
  isAdmin = false,
  alignCenter = true,
  columnSize = 5
}) => {
  const { t } = useTranslation('common')
  const companySizeValues = getCompanySizeMap()
  const [selectedIndustry, setSelectedIndustry] = useState(
    formik.values.industry?.length ? formik.values.industry[0] : ''
  )

  const handleIndustryChange = (e) => {
    const { name, value } = e.target
    setSelectedIndustry(value)
    formik.setFieldValue(name, value?.length ? [value] : '')
    formik.setFieldTouched(name)
  }

  return (
    <>
      <Col>
        <h6 className="section-name">{t('BASIC_INFORMATION')}</h6>
      </Col>

      <Form.Group
        as={Col}
        md={columnSize}
        controlId="formCompanyName"
        className={alignCenter ? 'mx-auto' : ''}
      >
        <Form.Label>{t('Company_name')}</Form.Label>
        <Form.Control
          type="text"
          name="tenantName"
          defaultValue={formik.values.tenantName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.tenantName}
          maxLength={255}
          readOnly={!canEdit}
        />
        <Form.Control.Feedback type="invalid">{formik.errors.tenantName}</Form.Control.Feedback>
      </Form.Group>
      <Form.Group
        as={Col}
        md={columnSize}
        controlId="formCompanyWebsite"
        className={alignCenter ? 'mx-auto' : ''}
      >
        <Form.Label>
          {t('Company_website')}
          <span className="form-optional">({t('Optional')})</span>
        </Form.Label>
        <Form.Control
          type="text"
          name="website"
          defaultValue={formik.values.website}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="e.g. https://companyname.com"
          isInvalid={!!formik.errors.website}
          maxLength={255}
          readOnly={!canEdit}
          required
        />
        <Form.Control.Feedback type="invalid">{formik.errors.website}</Form.Control.Feedback>
      </Form.Group>
      <Form.Group
        as={Col}
        md={columnSize}
        controlId="formIndustry"
        className={alignCenter ? 'mx-auto' : ''}
      >
        <Form.Label>{t('Industry')}</Form.Label>
        <Form.Control
          as="select"
          name="industry"
          isInvalid={!!formik.errors.industry}
          value={selectedIndustry || formik.values.industry}
          onChange={handleIndustryChange}
          disabled={!canEdit}
          required
        >
          <option value="" defaultValue>
            - {t('Select')} -
          </option>
          {industryValues.map((item) => (
            <option value={item} key={`industry-${item}`}>
              {item}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback className="invalid-feedback d-block">
          {formik.errors.industry}
        </Form.Control.Feedback>
      </Form.Group>
      {!isAdmin && (
        <Form.Group
          as={Col}
          md={columnSize}
          controlId="formCompanyPhone"
          className={alignCenter ? 'mx-auto' : ''}
        >
          <Form.Label>{t('Company_phone')}</Form.Label>
          <Form.Control
            required
            type="text"
            name="officeNumber"
            defaultValue={formik.values.officeNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.errors.officeNumber}
            maxLength={30}
          />
          <Form.Control.Feedback type="invalid">{formik.errors.officeNumber}</Form.Control.Feedback>
        </Form.Group>
      )}
      <Form.Group
        as={Col}
        md={columnSize}
        controlId="formCompanySize"
        className={alignCenter ? 'mx-auto' : ''}
      >
        <Form.Label>{t('Company_size')}</Form.Label>
        <Form.Control
          as="select"
          name="companySize"
          isInvalid={!!formik.errors.companySize}
          value={formik.values.companySize}
          onChange={formik.handleChange}
          disabled={!canEdit}
          required
        >
          <option value="" defaultValue>
            - {t('Select')} -
          </option>
          {companySizeValues.map((size, index) => (
            <option value={size.value} key={`company-size-${index}`}>
              {size.name}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">{formik.errors.companySize}</Form.Control.Feedback>
      </Form.Group>
    </>
  )
}

export default connect(CompanyInfoFieldsGroup)
